/**
 * Map UAE Pass nationality code (e.g., "IND", "ARE") to nationality value (e.g., "Indian", "Emirati")
 */
export function mapNationalityCodeToValue(nationalityCode: string): string {
    const mapping: Record<string, string> = {
        'IND': 'Indian',
        'ARE': 'Emirati',
        'SAU': 'Saudi Arabian',
        'EGY': 'Egyptian',
        'PAK': 'Pakistani',
        'BGD': 'Bangladeshi',
        'PHL': 'Filipino',
        'LKA': 'Sri Lankan',
        'NPL': 'Nepalese',
        'JOR': 'Jordanian',
        'LBN': 'Lebanese',
        'SYR': 'Syrian',
        'IRQ': 'Iraqi',
        'YEM': 'Yemeni',
        'OMN': 'Omani',
        'KWT': 'Kuwaiti',
        'BHR': 'Bahraini',
        'QAT': 'Qatari',
        'USA': 'American',
        'GBR': 'British',
        'CAN': 'Canadian',
        'AUS': 'Australian',
        'FRA': 'French',
        'DEU': 'German',
        'ITA': 'Italian',
        'ESP': 'Spanish',
        'JPN': 'Japanese',
        'KOR': 'South Korean',
        'CHN': 'Chinese',
        'RUS': 'Russian',
        'BRA': 'Brazilian',
        'ARG': 'Argentinian',
        'MEX': 'Mexican',
        'ZAF': 'South African',
        'NGA': 'Nigerian',
    };

    return mapping[nationalityCode] || nationalityCode;
}

